// FIX ME: server side からとってきたのを参照する
export enum ChanceTimeId {
  NewUser = 1,
  PremiumReviveUser = 2,
  AfterChurnUser = 3,
}

export enum Duration {
  NewUser = 1800,
  PremiumReviveUser = 1800,
  AfterChurnUser = 1800,
}

export enum MaxCounter {
  NewUser = 10,
  PremiumReviveUser = 10,
  AfterChurnUser = 10,
}

export enum Incentive {
  NewUser = 30,
  PremiumReviveUser = 30,
  AfterChurnUser = 30,
}

export class ChanceTime {
  max_counter: number;
  category: string;
  chance_time_id: number;
  counter: number;
  start_at: Date;
  end_at: Date;
  state: string;

  constructor(fields: any) {
    for (const f in fields) {
      this[f] = fields[f];
    }
  }

  isNewChanceTime(): boolean {
    return this.chance_time_id === ChanceTimeId.NewUser;
  }

  isPremiumReviveChanceTime(): boolean {
    return this.chance_time_id === ChanceTimeId.PremiumReviveUser;
  }

  isAfterChurnChanceTime(): boolean {
    return this.chance_time_id === ChanceTimeId.AfterChurnUser;
  }

  isNotFired(): boolean {
    return this.state === "not_fired";
  }

  isRunning(): boolean {
    return this.state === "running";
  }

  isCompleted(): boolean {
    return this.state === "completed";
  }

  isNotAchieved(): boolean {
    return this.state === "not_achieved";
  }

  getChanceTimeId(): number {
    return this.chance_time_id;
  }

  getEndAt(): Date {
    return new Date(this.end_at);
  }

  getStartAt(): Date {
    return new Date(this.start_at);
  }

  getMaxCounter(): number {
    return this.max_counter;
  }

  getRemainingSeconds(): number {
    return Math.floor(
      (this.getEndAt().getTime() - new Date().getTime()) / 1000
    );
  }

  getRemainingPoint(): number {
    return this.max_counter - this.counter;
  }
}



// WEBPACK FOOTER //
// ./src/models/chance-time.ts